import axios from 'axios'
export default {
    getAllAcademicEvents(state){
        //console.log(state.month[state.d.getMonth() ])
        let v = state.month[state.d.getMonth()].split('_')
        axios.get(state.root + 'academicevents/?slug=' +  v[0] + '-' + v[1])
          .then(function (response) {
            //console.log(response.data[0].acf.ncu_media)
            let q = response.data[0].acf
            // /state.upcomingEvents = []
            console.log(q)
    
            state.dayIndex = q.first_day
            //console.log(q.prevmonthdays - q.first_day)
            let trailer = q.prevmonthdays - q.first_day
    
            let l = []
    
            for (let i = 0; i < q.first_day; i++){
              //console.log(trailer + i)
              let x = {
                eventDay: (trailer + i) + 1,
                eventClass: 'shades'
              }
              l.push(x)
            }
            //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
           // if(state.month[state.d.getMonth()] === 'february_2019'){
              state.academicCalendar[state.monthTracker[1]] = []
            if(state.d.getMonth() === 11) {
              state.monthTracker = [state.month[state.d.getMonth() - 1], state.month[state.d.getMonth()], state.month[0],]
            } else {
              state.monthTracker = [state.month[state.d.getMonth() - 1], state.month[state.d.getMonth()], state.month[state.d.getMonth() + 1],]
            }
    
              //k.currentMonth = state.monthTracker.currentMonth
            console.log(q.currentmonthlength)
              for(let i = 0; i < q.currentmonthlength; i++){
                let k = {}
    
                console.log(i)
                //console.log(state.month[state.d.getMonth()])
                k.weekday = state.days[state.dayIndex]
                if (state.dayIndex >= 6 ){
                  state.dayIndex = 0
                }
                else {
                  state.dayIndex++
                }
                k.eventDay = i + 1
    
                //console.log(q.first_day)
                //console.log(q[i + 1] )
                if(q[i + 1] !== ""){
                  k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
                  k.eventDetail.pop()
                  k.eventClass = 'shadez'
                  l.push(k)
                  //console.log(l.length)
                  if (l.length === 7){
                    //console.log("full")
                    state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                    l = []
                  }
                }else {
                  k.eventDetail = ""
                  k.eventClass = 'shade'
                  l.push(k)
                 // console.log(l.length)
                  if (l.length === 7){
                   // console.log("full")
                    state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                    l = []
                  }
                }
                if (i >= q.currentmonthlength - 1){
                    state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                    l = []
    
                }
    
              }
            //}
    
          })
          .catch(function (error) {
            console.log(error);
          });
    
      },
    getNewAcademicEvents(state, payload){

        let v = state.month[payload.monthIndex].split('_')
        console.log(v)
        axios.get(state.root + 'academicevents/?slug=' +  v[0] + '-' + v[1])
          .then(function (response) {
            //console.log(response.data[0].acf.ncu_media)
            let q = response.data[0].acf
            // /state.upcomingEvents = []
            console.log(q)
            state.dayIndex = q.first_day
            let l =[]
            let trailer = q.prevmonthdays - q.first_day
            //console.log(trailer)
            //let l = []
    
            for (let i = 0; i < q.first_day; i++){
              console.log(trailer + i + 1)
              let x = {
                eventDay: (trailer + i) + 1,
                eventClass: 'shades'
              }
              l.push(x)
            }
            //console.log(state.month[payload.monthIndex])
            //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
            //if(state.month[payload.monthIndex] === 'february_2019'){
              state.monthTracker = []
            if(payload.monthIndex === 0){
              state.monthTracker = [ state.month[11],  state.month[payload.monthIndex], state.month[1], ]
            }
            else if(payload.monthIndex === 11){
                state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[0], ]
              }else
              {
                state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[payload.monthIndex +1], ]
              }
    
    
              state.academicCalendar[state.monthTracker[1]] = []
    
    
              for(let i = 0; i < q.currentmonthlength; i++){
              console.log(i)
                let k = {}
                //console.log(state.month[state.d.getMonth()])
    
                k.weekday = state.days[state.dayIndex]
                if (state.dayIndex >= 6 ){
                  state.dayIndex = 0
                }
                else {
                  state.dayIndex++
                }
                k.eventDay = i + 1
                //console.log(i)
                //console.log(q[i + 1] )
                if(q[i + 1] !== ""){
                  k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
                  k.eventDetail.pop()
                  k.eventClass = 'shadez'
                  l.push(k)
                   //console.log(l.length)
                  if (l.length === 7){
                    state.academicCalendar[state.month[payload.monthIndex]].push(l)
                    l = []
                  }
                }else {
                  k.eventDetail = ""
                  k.eventClass = 'shade'
                  l.push(k)
                  //console.log(l.length)
                  if (l.length === 7){
                    state.academicCalendar[state.month[payload.monthIndex]].push(l)
                    l = []
                  }
                }
                if (i >= q.currentmonthlength - 1){
                  state.academicCalendar[state.month[payload.monthIndex]].push(l)
                  l = []
    
                }
    
              }
            //}
          })
          .catch(function (error) {
            console.log(error);
          });
    
      },
    getAllEvents(state){
      console.log(state.month[state.d.getMonth() ])
      let v = state.month[state.d.getMonth()].split('_')
      axios.get(state.root + 'events/?slug=' +  v[0] + '-' + v[1])
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          let q = response.data[0].acf
          // /state.upcomingEvents = []
          console.log(q)

          state.dayIndex = q.first_day
          //console.log(q.prevmonthdays - q.first_day)
          let trailer = q.prevmonthdays - q.first_day

          let l = []

          for (let i = 0; i < q.first_day; i++){
            //console.log(trailer + i)
            let x = {
              eventDay: (trailer + i) + 1,
              eventClass: 'shades'
            }
            l.push(x)
          }
          //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
          // if(state.month[state.d.getMonth()] === 'february_2019'){
          state.eventsCalendar[state.monthTracker[1]] = []

          if(state.d.getMonth() === 11){
            state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[0], ]
          }else {
            state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[state.d.getMonth() + 1], ]
          }

          //k.currentMonth = state.monthTracker.currentMonth
         // console.log(q.currentmonthlength)
          for(let i = 0; i < q.currentmonthlength; i++){
            let k = {}

            //console.log(i)
            //console.log(state.month[state.d.getMonth()])
            k.weekday = state.days[state.dayIndex]
            if (state.dayIndex >= 6 ){
              state.dayIndex = 0
            }
            else {
              state.dayIndex++
            }
            k.eventDay = i + 1

            //console.log(q.first_day)
            //console.log(q[i + 1] )
            if(q[i + 1] !== ""){
              k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
              k.eventDetail.pop()
              k.eventClass = 'shadez'
              l.push(k)
              //console.log(l.length)
              if (l.length === 7){
                //console.log("full")
                state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
                l = []
              }
            }else {
              k.eventDetail = ""
              k.eventClass = 'shade'
              l.push(k)
              // console.log(l.length)
              if (l.length === 7){
                // console.log("full")
                state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
                l = []
              }
            }
            if (i >= q.currentmonthlength - 1){
              state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
              l = []

            }

          }
          //}

        })
        .catch(function (error) {
          console.log(error);
        });

    },
    getNewEvents(state, payload){
    
        console.log(state.month[payload.monthIndex])
        let v = state.month[payload.monthIndex].split('_')
        //console.log(v[0] + '-' + v[1])
        axios.get(state.root + 'events/?slug=' +  v[0] + '-' + v[1])
          .then(function (response) {
            //console.log(response.data[0].acf.ncu_media)
            let q = response.data[0].acf
            // /state.upcomingEvents = []
            console.log(q)
            state.dayIndex = q.first_day
            let l =[]
            let trailer = q.prevmonthdays - q.first_day
            //console.log(trailer)
            //let l = []
    
            for (let i = 0; i < q.first_day; i++){
              console.log(trailer + i + 1)
              let x = {
                eventDay: (trailer + i) + 1,
                eventClass: 'shades'
              }
              l.push(x)
            }
            //console.log(state.month[payload.monthIndex])
            //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
            //if(state.month[payload.monthIndex] === 'february_2019'){
            state.monthTracker = []
              console.log(state.monthIndex)
            if(payload.monthIndex === 0){
              state.monthTracker = [ state.month[11],  state.month[payload.monthIndex], state.month[1], ]
            }
            else if(payload.monthIndex === 11){
              state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[0], ]
            }else
            {
              state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[payload.monthIndex +1], ]
            }
    
    
            state.eventsCalendar[state.monthTracker[1]] = []
            //state.eventsCalendar[state.monthTracker[1]] = []
            //state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[state.d.getMonth() +1], ]
    
            for(let i = 0; i < q.currentmonthlength; i++){
              console.log(i)
              let k = {}
              //console.log(state.month[state.d.getMonth()])
    
              k.weekday = state.days[state.dayIndex]
              if (state.dayIndex >= 6 ){
                state.dayIndex = 0
              }
              else {
                state.dayIndex++
              }
              k.eventDay = i + 1
              //console.log(i)
              //console.log(q[i + 1] )
              if(q[i + 1] !== ""){
                k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
                k.eventDetail.pop()
                k.eventClass = 'shadez'
                l.push(k)
                //console.log(l.length)
                if (l.length === 7){
                  state.eventsCalendar[state.month[payload.monthIndex]].push(l)
                  l = []
                }
              }else {
                k.eventDetail = ""
                k.eventClass = 'shade'
                l.push(k)
                //console.log(l.length)
                if (l.length === 7){
                  state.eventsCalendar[state.month[payload.monthIndex]].push(l)
                  l = []
                }
              }
              if (i >= q.currentmonthlength - 1){
                state.eventsCalendar[state.month[payload.monthIndex]].push(l)
                l = []
    
              }
    
            }
            //}
          })
          .catch(function (error) {
            console.log(error);
          });
    
    },
    getArticles(state){
      axios.get(state.news_root + '/newsarticles')
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          let q = response.data
          state.newsArticleSlide = []
          console.log(q)
          //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
          for(let i =0; i < 10; i++){
            let k = {}
            k.title = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""); //remove p tags
            k.articleImage = q[i].acf.articlecoverimage
            k.paragraph2 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
            k.articleImage1 = q[i].acf.article_image_1
              console.log(k)
            //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
            state.newsArticleSlide.push(k)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getArticle(state, payload){
      //this.$router.push({'path': '/app'})
      //router.push({ path: '/article', query: { plan: 'private' }})
      console.log(payload)
      axios.get(state.news_root + '/' + payload.articleType + '/?slug=' + payload.articleName)
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          state.viewArticle = []
          let q = response.data
          console.log(q)
          for(let i =0; i < 10; i++){
            let k = {}
            k.articleTitle = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>)/img, "").replace(/(<\/p>)/img, "*").split('*'); //remove p tags
            k.articleImage = q[i].acf.articlecoverimage
            k.paragraph2 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
            k.articleImage1 = q[i].acf.article_image_1
            k.writer = q[i].acf.writer
  
            //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
            state.viewArticle.push(k)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getSportArticles(state){
      axios.get(state.news_root + '/sportsarticles')
        .then(function (response) {
          //console.log(response.data[0].acf.ncu_media)
          let q = response.data
          state.sportsArticleSlide = []
          console.log(q)
          //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
          for(let i =0; i < 10; i++){
            let k = {}
            k.title = q[i].title['rendered']
            k.articleType = q[i].type
            k.slug = q[i].slug
            k.id = q[i].id
            k.date_created = q[i].date
            k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""); //remove p tags
            k.articleImage = q[i].acf.articlecoverimage
            k.paragraph2 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
            k.articleImage1 = q[i].acf.article_image_1
            k.paragraph3 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
            //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
            state.sportsArticleSlide.push(k)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    /*getUpcomingEvents(state){
        axios.get(state.strapiApi + 'upcoming-events')
        .then(response => {
            console.log(response.data)

            state.UpcomingEventsList =[]
            for (let i = 0; i< response.data.length; i++){
              state.UpcomingEventsList.push(response.data[i])
            }
        })
        .catch(err => {
          console.log('2')
        })
    },*/
    getUpcomingEvents(state){
        axios({
            method: 'get',
            url: state.rootUrl +  'getUpcomingEvents',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
        })
            .then(response => {

                if (response.status === 201 ){
                    state.UpcomingEventsList =[]
                    for (let i = 0; i< response.data.UpcomingEvents.length; i++){
                        state.UpcomingEventsList.push(response.data.UpcomingEvents[i])
                    }
                }
                else{
                    console.log('1')
                }
            })
            .catch(err => {
                console.log('2')
            })
    },
    getUpcomingEvent(state, payload){
     // console.log(payload)
        //axios.get(state.strapiApi + 'upcoming-events' + '\\' + payload.eventID)
      axios({
        method: 'post',
        url: state.rootUrl + 'getSingleUpcomingEvent',
        //headers: {'Authorization': 'Bearer ' + Vue.localStorage.get('token')},
        data: {
          eventID: payload.eventID
        }
      })
        .then(response => {

          //if (response.status === 201) {
            console.log(response.data)
            state.UpcomingEvent ={}
            state.UpcomingEvent = {
              "upcomingEventName": response.data.UpcomingEvent[0].upcomingEventName,
              "upcomingEventImage": response.data.UpcomingEvent[0].upcomingEventImage,
              "upcomingEventImage2": response.data.UpcomingEvent[0].upcomingEventImage2,
              "_id": response.data.id
            }


        })
        .catch(err => {
          console.log(err)
        })

    }
}
